<!-- <loading [isLoading]="isLoading" [isFullSize]="true"></loading> -->
<!-- <div *ngIf="IsAuthenticated"> -->
<!-- panel -->
<app-panel-edit-geofences *ngIf="_isVisiblePanelEditGeofences"></app-panel-edit-geofences>
<panel-geofences *ngIf="_isVisiblePanelGeofences"></panel-geofences>
<panel-detail-geofences *ngIf="_isVisiblePanelDetailGeofences"></panel-detail-geofences>
<!-- end panel -->
<!-- </div> -->
<!-- <div *ngIf="!IsAuthenticated">
  <br><br><br><br>
  <h1 class="error">User not Authorized to enter this page</h1>
</div> -->
